module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form>\n    <dl class=\'stepped zero\'>\n        <dt>\n            <label for=\'zone_name\'>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'zone_name\' name=\'zone[name]\' type=\'text\'/>\n        </dd>\n\n\n        <div id=\'short_name_container\'>\n            <dt>\n                <label for=\'zone_short_name\'>' +
((__t = ( i18next.t('common.shortName') )) == null ? '' : __t) +
'</label>\n            </dt>\n            <dd>\n                <input class=\'text\' id=\'zone_short_name\' name=\'zone[short_name]\' type=\'text\'/>\n            </dd>\n        </div>\n\n\n        <dt>\n            <label for=\'zone_description\'>' +
((__t = ( i18next.t('common.description') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <textarea class=\'text small\' id=\'zone_description\' name=\'zone[description]\'></textarea>\n        </dd>\n\n        <dt>\n            <label for=\'zone_category_id\'>' +
((__t = ( i18next.t('common.category') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <select class=\'text\' id=\'zone_category_id\' name=\'zone[category_id]\'>\n                <option selected disabled>' +
((__t = ( i18next.t('ui.please_select_option') )) == null ? '' : __t) +
'</option>\n            </select>\n        </dd>\n        <input name=\'zone[organization_id]\' type=\'hidden\' value=\'' +
((__t = ( WiseMetering.currentOrganization.id )) == null ? '' : __t) +
'\'>\n\n        <dt>\n            <label for=\'zone_area\'>' +
((__t = ( i18next.t('common.area') )) == null ? '' : __t) +
' (m2)</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'zone_area\' name=\'zone[area]\' type=\'text\'/>\n        </dd>\n\n        <dt>\n            <label for=\'zone_capacity\'>' +
((__t = ( i18next.t('common.capacity') )) == null ? '' : __t) +
' (' +
((__t = ( i18next.t('common.persons') )) == null ? '' : __t) +
')</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'zone_capacity\' name=\'zone[capacity]\' type=\'text\'/>\n        </dd>\n\n        ';
 if (WiseMetering.siteTags.length) { ;
__p += '\n            <dt>\n                <label for=\'zone_tag_ids\'>' +
((__t = ( i18next.t('glossary.site_tags') )) == null ? '' : __t) +
'</label>\n            </dt>\n            <dd>\n                ';
 WiseMetering.siteTags.forEach(function(tag) { ;
__p += '\n            <dt style="margin-top: 5px !important;">\n                <input class="vertical-middle" id="tag_' +
((__t = ( tag.id )) == null ? '' : __t) +
'" name="zone[tag_ids][' +
((__t = ( tag.id )) == null ? '' : __t) +
']" type="checkbox" value="';
 tag.id ;
__p += '">\n                <label for="tag_' +
((__t = ( tag.id )) == null ? '' : __t) +
'">' +
((__t = ( tag.get('name') )) == null ? '' : __t) +
'</label>\n            </dt>\n            ';
 }) ;
__p += '\n            </dd>\n        ';
 } ;
__p += '\n\n        <dt>\n            <label class=\'decapitalize\' for="site-image">' +
((__t = ( i18next.t('sites.image_label') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input accept="image/png, image/jpeg, image/jpg" id="site-image" class=\'input-image text\' type=\'file\'>\n        </dd>\n\n        <input id=\'zone_latitude\' name=\'zone[latitude]\' type=\'hidden\'>\n        <input id=\'zone_longitude\' name=\'zone[longitude]\' type=\'hidden\'>\n\n        <dt>\n            <label for=\'address\'>' +
((__t = ( i18next.t('common.address') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'address\' placeholder=\'' +
((__t = ( i18next.t('zones.please_insert_an_address') )) == null ? '' : __t) +
'\' style=\'width: 536px;\'>\n        </dd>\n\n        <dt>\n            <label>' +
((__t = ( i18next.t('common.map') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <div id=\'map_canvas\' style=\'height:400px;\'></div>\n        </dd>\n        <dd class=\'last\'>\n            ' +
((__t = ( i18next.t('zones.please_drag_the_marker') )) == null ? '' : __t) +
'\n        </dd>\n    </dl>\n</form>\n';

}
return __p
}